import vPagination from './Pagination.vue';

export { vPagination };



// WEBPACK FOOTER //
// ./src/baseComponents/components/Pagination/index.js